import { render, staticRenderFns } from "./ServerErrorDialog.vue?vue&type=template&id=82123b5e&scoped=true&"
import script from "./ServerErrorDialog.vue?vue&type=script&lang=js&"
export * from "./ServerErrorDialog.vue?vue&type=script&lang=js&"
import style0 from "./ServerErrorDialog.vue?vue&type=style&index=0&id=82123b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82123b5e",
  null
  
)

export default component.exports